import { MenuItem, Select } from "@material-ui/core"
import React from "react"
import useAppStore from "../../../stores/AppStore"

export enum FiltroEntregaRetiradaEnum {
    TODOS = "-1",
    ENTREGA = "0",
    RETIRADA = "1",
    MESA = "2",
}

export default function FiltroEntregaRetirada() {
    const filtroEntregaRetirada = useAppStore(s => s.filtroEntregaRetirada)
    const setFiltroEntregaRetirada = useAppStore(s => s.setFiltroEntregaRetirada)

    return (
        <Select
            value={filtroEntregaRetirada}
            onChange={e => setFiltroEntregaRetirada(e.target.value as FiltroEntregaRetiradaEnum)}
            variant="outlined"
            style={{ maxHeight: "40px" }}
        >
            <MenuItem value={FiltroEntregaRetiradaEnum.TODOS}>Todos</MenuItem>
            <MenuItem value={FiltroEntregaRetiradaEnum.ENTREGA}>Entrega</MenuItem>
            <MenuItem value={FiltroEntregaRetiradaEnum.RETIRADA}>Retirada</MenuItem>
            <MenuItem value={FiltroEntregaRetiradaEnum.MESA}>Mesa</MenuItem>
        </Select>
    )
}
